import { Component, Input } from "@angular/core";
import { AuthSession } from "@ponder-core/auth/auth-session";

@Component({
    selector: "unauthorized",
    imports: [],
    templateUrl: "./unauthorized.component.html"
})
export class UnauthorizedComponent {
    @Input() public authSession?: AuthSession;
    
    public constructor() {

    }
}